<!--  -->
<template>
  <div class="container">
    <div class="tab-container" v-if="tabs.length">
      <div ref="tabList" class="tab-list" @scroll="scroll" :class="{ leftShadow: leftFlag }">
        <div
          ref="tabItem"
          class="tab-item"
          v-for="(item, index) in tabs"
          :key="index"
          @click="tabFilterRemarkList(item)"
        >
          <span class="tab-name" :class="{ focus: item.tagId == tagId }" v-text="item.tagName"></span>
          <span
            class="sub-name"
            :class="{ focus: item.tagId == tagId }"
            v-text="formatCount(item.evaluateNum) || 0"
          ></span>
        </div>
      </div>
      <div class="shadow"></div>
    </div>
  </div>
</template>

<script>
import { formatCount } from '@/utils/common'
import { mapGetters } from 'vuex'
export default {
  components: {},
  props: {
    tabList: {
      type: Array,
      default: () => {
        return []
      }
    },
    tagId: {
      type: [Number, String]
    }
  },
  data() {
    //这里存放数据
    return {
      leftFlag: false
    }
  },
  //监听属性 类似于data概念
  computed: {
    ...mapGetters('detailv3', ['spuId', 'skuId']),
    tabs() {
      return this.tabList.filter(el => {
        return el.evaluateNum || el.tagName == '全部'
      })
    }
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    formatCount,
    tabFilterRemarkList(item) {
      this.$track({
        cfrom: '105|002|01|077',
        event_id: '105|002|01|077',
        label_name: item.tagName,
        sku_id: this.skuId,
        spu_id: this.spuId
      })
      this.$emit('tabFilterRemarkList', item.tagId, item.tagName)
    },
    scroll(e) {
      if (e.target.scrollLeft == 0) {
        this.leftFlag = false
      } else {
        this.leftFlag = true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  position: absolute;
  left: 0;
  right: 0;
  padding: 30px 27px;
  padding-bottom: 0px;
  @include bgColor(#fafafa, #000);
}
.unfix {
  .container {
    position: relative;
  }
}
.tab-container {
  height: 142px;
  @include bgColor(#fff, $dark_bg_color);
  padding: 0px 36px;
  flex-shrink: 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border-top-left-radius: 36px;
  border-top-right-radius: 36px;
  z-index: 3;
  position: relative;
  .shadow {
    width: 149px;
    height: 144px;
    position: absolute;
    right: 0;
    border-top-right-radius: 36px;
    background: linear-gradient(
      270deg,
      #ffffff 0%,
      #ffffff 0.01%,
      rgba(255, 255, 255, 0.755284) 59.38%,
      rgba(255, 255, 255, 0) 100%
    );
    @media (prefers-color-scheme: dark) {
      background: linear-gradient(270deg, rgba(0, 0, 0, 0.15) 0%, rgba(0, 0, 0, 0.01) 0.01%, rgba(0, 0, 0, 0) 100%);
      background-size: 50px 100%;
      background-position: left;
      background-repeat: no-repeat;
    }
  }
}
.tab-list::-webkit-scrollbar {
  display: none;
}
.leftShadow {
  background: linear-gradient(
    to right,
    rgba(182, 183, 184, 0.14) -4.53%,
    rgba(200, 200, 200, 0.08) 63.3%,
    rgba(211, 211, 211, 0) 105%
  );
  background-size: 10px 100%;
  background-position: left;
  background-repeat: no-repeat;
  @media (prefers-color-scheme: dark) {
    background: linear-gradient(to right, rgba(0, 0, 0, 0.15) 13.52%, rgba(0, 0, 0, 0.01) 67.4%, rgba(0, 0, 0, 0) 105%);
    background-size: 50px 100%;
    background-position: left;
    background-repeat: no-repeat;
  }
}

.tab-list {
  height: 80px;
  width: 100%;
  overflow: auto;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  padding-right: 70px;

  .tab-item {
    flex-shrink: 0;
    height: 35px;
    padding-right: 36px;
    white-space: nowrap;
    display: flex;
    align-items: flex-end;
  }

  :last-child {
    padding-right: 0;
  }

  .tab-name {
    font-size: 36px;
    line-height: 45px;
    @include os-font-weight(36, 50);
    @include fontColor(#000, #fff);
  }

  .sub-name {
    margin-left: 6px;
    font-size: 30px;
    line-height: 39px;
    color: #999999;
    @include os-font-weight(30, 50);
  }

  .focus {
    @include fontColor($brand-text, $brand-text-dark);
  }
}
</style>
